<template>
  <app-dialog v-model="joinUsDialog" max-width="600px" :title="currentTitle" @click:outside="close">
    <component :is="formSteps[currentStep].component" @prev-step="onPrevStep" @next-step="onNextStep" @close="close" @refresh="refresh" />
  </app-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AgentFeatures from '@/components/storefront/AgentFeatures'
import AgentSignUpForm from '@/components/storefront/AgentSignUpForm'
import ReferralForm from '@/components/storefront/ReferralForm.vue'
import AgentTnc from '@/components/storefront/AgentTnc.vue'
import { localeHelper } from '@/utils'
import AgentSignUpSuccess from './AgentSignUpSuccess.vue'

export default {
  components: { AgentFeatures, AgentSignUpForm, ReferralForm },

  props: ['value'],

  data() {
    return {
      currentStep: 0,
      formSteps: [
        { component: AgentFeatures, title: localeHelper.getMessage('label.whyJoinUs') },
        { component: AgentSignUpForm, title: localeHelper.getMessage('label.joinAsPartner') },
        { component: ReferralForm, title: localeHelper.getMessage('label.referralCode') },
        { component: AgentTnc, title: localeHelper.getMessage('label.termsAndConditions') },
        { component: AgentSignUpSuccess, title: '' }
      ]
    }
  },

  computed: {
    ...mapState('auth', ['currentUser']),
    ...mapState('agent', ['isPendingAgentTnc']),
    joinUsDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.currentStep = 0
        this.$emit('input', val)
      }
    },

    currentTitle() {
      return this.formSteps[this.currentStep].title
    }
  },
  mounted() {
    if (this.isPendingAgentTnc) this.currentStep = 3
  },
  methods: {
    ...mapActions('auth', ['getProfile', 'loadProfile']),
    ...mapActions('agent', ['getAgentApplicationStatus']),
    close() {
      this.loadProfile()
      if (this.currentUser) this.getAgentApplicationStatus()
      this.$emit('input', false)
    },
    refresh() {
      location.reload()
    },
    onNextStep() {
      if (this.currentStep === this.formSteps.length - 1) {
        this.currentStep = 0
        this.loadProfile()
        close()
        return
      }
      if (!this.currentUser) {
        this.$emit('input', false)
        this.$root.$app.openLoginDialog()
      }
      this.currentStep++
    },

    onPrevStep() {
      if (this.currentStep > 0) this.currentStep--
    }
  }
}
</script>
